import _ from 'lodash';

import { compareNatural } from '@zapier/services/esm/utils';

import { measure } from '../PerformanceUtils';

import { Service } from '@zapier/services/esm/types';

const resolver = (services: Service[]) => {
  // We may receive isFollowing as part of a separate asynchronous action, and
  // need to consider it as a separate part of a service identity here.
  return _.join(_.map(services, s => `${s.name}${s.isFollowing}`));
};

export const sortByFollowedAndPopularityRank = measure(
  'sortByFollowedAndPopularityRank',
  _.memoize((services: Array<Service>): Array<Service> => {
    // Note that each block has an early return for performance
    // optimizations. Without this, sorting is roughly 10x slower.
    return services.sort((serviceA, serviceB) => {
      const popularityA = serviceA.popularity || 9999;
      const popularityB = serviceB.popularity || 9999;
      const comparePopularity = popularityA - popularityB;

      if (serviceA.isFollowing && serviceB.isFollowing) {
        return comparePopularity
          ? comparePopularity
          : compareNatural(
              _.toString(serviceA.name),
              _.toString(serviceB.name)
            );
      } else if (serviceA.isFollowing) {
        return -1;
      } else if (serviceB.isFollowing) {
        return 1;
      }

      if (comparePopularity) {
        return comparePopularity;
      }

      const compareName = compareNatural(
        _.toString(serviceA.name),
        _.toString(serviceB.name)
      );

      return compareName;
    });
  }, resolver)
);

export default sortByFollowedAndPopularityRank;
